package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_08_01_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth shows the other heroes that Razorwrath has transformed from Long Sword to Great Sword.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes want to meet Goram when he arrives at the Powerglow Guild’s teleportation circle at 10 a.m. They suspect they can seriously annoy the jumpy nerds in the guild by teleporting in unannounced at 9:59 a.m. When they arrive, Magister Vivian Huff yells at them to get off the circle.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Lady Aventary and Goram Frok appear. Goram has new plate armor. He looks tired but healthy. He greets the heroes. Lady Aventary gives a status report on behalf of The Peers.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("The teleportation circles in the Dorvidian Empire have all been shut down.")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Ronavir - on the west coast / north of Pentish")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Glavor - central - east of Pentish")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Dorvid - the capital / south coast / south of Pentish")
            }
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Dorvidia militarizing for something. Was there a “falling out” between Lord Pent and Emperor? Perhaps.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Travel options")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("by sea to Ronavir")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("by land")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("follow river and meet with Dwarves to then to Birlat Among the Dwarves of Ladikor, seek out Midrack Vorkun of the Peers.")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes return to their bastion around noon. Caper tells Bigglesworth that the sword smells like foul evil. Bigglesworth is afflicted by exhaustion again. Caper, Goram, and Falorn convince Bigglesworth to give up the sword. Falorn breaks his attunement. As Bigglesworth feels Razorwrath’s presence vanish, the blade briefly cries out.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper carefully picks up the blade wrapped in a cloak. She places it in the armory on the 4th floor.")
    }
}
